/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Render_Audio_Failed_Retry_ToastInputs */



/**
* | output |
* | --- |
* | "Converting text to speech audio failed. Please Retry:{error}" |
*
* @param {Render_Audio_Failed_Retry_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const render_audio_failed_retry_toast = /** @type {((inputs: Render_Audio_Failed_Retry_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Render_Audio_Failed_Retry_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de la conversion du texte en audio. Veuillez reessayer :${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Umwandlung von Text in Sprache ist fehlgeschlagen. Bitte versuchen Sie es erneut:${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Conversione del testo in audio vocale non riuscita. Riprova: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось преобразовать текст в аудиозапись. Пожалуйста, повторите попытку:${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al convertir texto a audio de voz. Vuelva a intentarlo: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`文本转语音失败。请重试：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`テキストを音声に変換できませんでした。再試行してください:${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`टेक्स्ट को ऑडियो स्पीच में परिवर्तित करने में विफलता मिली। कृपया पुनः प्रयास करें:${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A conversão de texto em áudio de fala falhou. Tente novamente: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Converting text to speech audio failed. Please Retry:${i?.error}`)
});